// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewBadges_wrapper__BdHSY","inner":"ReviewBadges_inner__Tzxiw","item":"ReviewBadges_item__ocbnI"};